module.exports = __webpack_public_path__ + "media/images/map-icons/mapbox-outdoors-f3cd8c604c54e6792c08ce14a9817779.png";